import { useMemo } from 'react'
import moment from 'moment'

export const checkIsEventClosed = (event) => {
  if (!event) return false

  const currentTimestamp = moment().unix()
  const isClosedByTime = event?.closingTimestamp
    ? currentTimestamp > Number(event.closingTimestamp)
    : false

  return (
    isClosedByTime ||
    event?.status === 'CLOSED' ||
    event?.status === 'closed' ||
    event?.status === 0 ||
    Boolean(event?.isClosed)
  )
}

const useIsEventClosed = (event) => useMemo(
  () => checkIsEventClosed(event),
  [event?.closingTimestamp, event?.status, event?.isClosed],
)

export default useIsEventClosed
